import { render, staticRenderFns } from "./GlobalsLifecycle.vue?vue&type=template&id=3ba65f58&scoped=true"
import script from "./GlobalsLifecycle.vue?vue&type=script&lang=js"
export * from "./GlobalsLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba65f58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projekte\\Tipsiolive\\tipsiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ba65f58')) {
      api.createRecord('3ba65f58', component.options)
    } else {
      api.reload('3ba65f58', component.options)
    }
    module.hot.accept("./GlobalsLifecycle.vue?vue&type=template&id=3ba65f58&scoped=true", function () {
      api.rerender('3ba65f58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lifecycle/GlobalsLifecycle.vue"
export default component.exports